<template>
  <div class="pa-10 page-not-found access-denied text-center">
    <div class="page-note-found-inner text-black pt-10">
      <small>404</small>
      <h1 class="mt-3">Not Found!</h1>
      <p class="lead my-4">
        The requested resource could not be found but may be available again in the future.
      </p>
      <p>Contact operations@functionize.com, If the problem persists.</p>
      <div class="row">
        <div class="col-12 py-5">
          <v-btn class="bg-main text-white font-weight-bold" @click="goBack">
            <v-icon>mdi-arrow-left</v-icon>
            Go Back
          </v-btn>
        </div>
        <div class="col-12">
          <accessError class="access-error" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import accessError from "@/assets/svg/404-error.svg";

export default {
  name: "InvalidRoute",
  components: {
    accessError,
  },
  mounted() {
    localStorage.setItem("directNavigation", "true");
  },
  methods: {
    goBack() {
      if (localStorage.getItem("directNavigation") === "true") {
        this.$store.commit("resetCheckAccessInfo", false);
        this.$router.replace({
          name: "Projects",
          params: {
            clearHistory: true,
          },
        });
        localStorage.removeItem("directNavigation");
      } else if (window.history?.length > 1) {
        this.$router.go(-1);
      } else {
        this.$store.commit("resetCheckAccessInfo", false);
        this.$router.replace({
          name: "Projects",
          params: {
            clearHistory: true,
          },
        });
      }
      this.$store.commit("setInvalidRoute", false);
    },
  },
};
</script>

<style scoped></style>
